module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-27.e0fa8af9.svg";